// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Colored_text, t_colors} from '../ui/about/colored_text';
import styles from './hero_info.module.less';

interface i_about_hero_props {
  h1: string;
  h2_1: string;
  h2_2: string;
  h2_3: string;
}

const About_hero = (props: i_about_hero_props)=>{
    const {h1, h2_1, h2_2, h2_3} = props;
    const h2_lines: [string, t_colors][] = [
        [h2_1, 'blue'],
        [h2_2, 'pink'],
        [h2_3, 'yellow'],
    ];
    return <div className={styles.hero}>
      <h1 className={styles.h1}>{h1}</h1>
      <h2>
        {h2_lines.map(([s, c], i)=><Colored_text key={i} text={s} color={c}/>)}
      </h2>
    </div>;
};

const About_info = ()=>{
    return <section className={styles.info}>
      <div className={styles.col}>
        <p className={styles.title}>4.9 stars</p>
        <p className={styles.text}>in Chrome Web Store</p>
      </div>
      <div className={styles.col}>
        <p className={styles.title}>263 million</p>
        <p className={styles.text}>downloads and counting</p>
      </div>
      <div className={styles.col}>
        <p className={styles.title}>195 countries</p>
        <p className={styles.text}>to browse from</p>
      </div>
    </section>;
};

export const Hero_info = (props: i_about_hero_props)=>{
    const {h1, h2_1, h2_2, h2_3} = props;
    return <div className={styles.hero_info_wrapper}>
        <About_hero h1={h1} h2_1={h2_1} h2_2={h2_2} h2_3={h2_3} />
        <About_info/>
    </div>;
};

interface i_hero_info_editor_props {
    value: i_about_hero_props;
    on_change: (new_val: i_about_hero_props)=>void;
}

export const Hero_info_editor = (props: i_hero_info_editor_props)=>{
    const {value, on_change} = props;
    return <Editor value={value} on_change={on_change} editors={[
      {key: 'h1', label: 'H1 (smaller)', type: 'text'},
      {key: 'h2_1', label: 'Blue H2', type: 'text'},
      {key: 'h2_2', label: 'Pink H2', type: 'text'},
      {key: 'h2_3', label: 'Yellow H2', type: 'text'},
    ]}/>;
};
